import styled, { createGlobalStyle } from 'styled-components';
import { Button, Tooltip, Tag } from 'antd';

export const TypeComponent = styled('div')`
  .editable-cell {
    position: relative;
  }

  .editable-cell-value-wrap {
    padding: 0;
    cursor: pointer;
    color: black !important;
    border: none;
    border-radius: 2px;
    border: 1px solid white;
    background: white;
    outline: 0;
    background-color: #fff;
  }

  .editable-row:hover .editable-cell-value-wrap {
    border: 1px solid white;
    border-radius: 4px;
  }

  .editable-cell-value-wrap:empty {
    padding: 15px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
  }

  .ant-table-cell a {
    &:hover {
      color: black;
    }
  }
  .ant-picker-dropdown {
    z-index: 1050;
  }
  .ant-table-cell-row-hover .ant-picker {
    pointer-events: auto;
  }
  .ant-picker-input {
    color: black !important;
  }

  .ant-table-wrapper .ant-table-pagination.ant-pagination {
    // margin: 0 0 16px 0;
    margin: 16px;
  }

  .ant-pagination {
    position: absolute;
    top: -72px;
    right: 0;
  }
`;

export const OperationsRow = styled.a`
  color: black;

  span svg {
    font-size: 20px;
  }
`;

export const AreaButton = styled(Button)<{ token: any }>`
  // margin: 16px;
  z-index: 1;

  background: ${({ token }) => token.actionButtons};
  width: 170px;
  margin: 10px 0;

  &:hover {
    background-color: ${({ token }) => token.actionButtonsHover} !important;
  }
`;

export const BranchArea = styled('div')`
  position: relative;
  top: -121px;
  text-align: start;
  left: 190px;
  display: none;
`;

export const GlobalStyle = createGlobalStyle`
  body {
    .ant-tooltip-inner {
      width: 430px;
      padding: 12px !important;
      div {
        padding: 1px 0;
        border-bottom: 1px solid #d9d9d9;
        input {
          margin-left: 0;
        }
        strong, span{
          font-size: 16px;
          width: auto;
        }
      }
      div:last-child {
        border-bottom: none;
      }
    }
    
    .ant-tooltip-inner .ant-select {
      width: 220px !important;
      max-width: 220px !important;
      min-width: 220px !important;
    }
    
    .ant-tooltip-inner .ant-select .ant-select-selector {
      width: 220px !important;
      max-width: 220px !important;
      min-width: 220px !important;
      height: 32px !important;
      display: flex !important;
      align-items: center !important;
    }
    
    .ant-tooltip-inner .ant-select-selection-item {
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      white-space: nowrap !important;
      max-width: calc(100% - 24px) !important;
      flex: 1 !important;
      font-size: 14px !important;
    }
    
    .ant-tooltip-inner .ant-select-selection-search {
      width: 100% !important;
      max-width: 100% !important;
    }
    
    .ant-tooltip-inner input {
      font-size: 14px !important;
      margin-top: -4px !important;
    }
    
    .ant-tooltip-inner .ant-picker {
      margin-top: -6px !important;
      border: none !important;
      padding-right: 8px !important;
    }
    
    .ant-tooltip-inner .ant-picker-input {
      border-bottom: none !important;
      padding-left: 7px !important;
      padding-top: 5px !important;
    }
    
    .ant-tooltip-inner .ant-input {
      width: 220px !important;
    }
  }
`;
export const InputField = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 8px;

  strong {
    flex-shrink: 0;
    min-width: 180px;
    max-width: 180px;
    word-wrap: break-word;
    white-space: normal;
    line-height: 1.4;
  }

  .ant-picker .ant-picker-input input {
    width: auto;
    display: flex;
    flex: none;
  }

  input {
    width: auto;
  }
`;
export const TooltipContainer = styled(Tooltip)`
  cursor: pointer;
`;

export const AddButton = styled(Button)`
  &.ant-btn {
    color: black !important;
  }
  .ant-btn-icon > svg {
    fill: black;
  }
`;

export const TooltipButtonContainer = styled('div')`
  text-align: end;
  display: flex;
  justify-content: space-between;
  padding-bottom: 5px !important;

  button {
    color: white;
  }

  button:nth-child(2) {
    background-color: #e6b84c;
    color: #fff;
    border: none;
    border-radius: 4px;
    padding: 2px 8px;
    font-weight: 500;
    cursor: pointer;

    &:hover {
      background-color: #d9a63f !important;
    }
  }
`;

export const TagComponent = styled(Tag)`
  padding: 0;
  border: none;

  input {
    background: #e6f4ff;
  }

  .ant-input-group-addon {
    cursor: pointer;
    color: #fff !important;
  }
`;

export const TooltipTableContainer = styled('div')`
  .ant-table-wrapper {

    .ant-pagination {
      margin: 16px;
      position: absolute;
      top: -74px;
      right: 0;
    }
    .ant-picker-input {
      color: black !important;
    }
  }

  .highlighted-column {
    background-color: #ffcd0b4a;
  }

  }
`;

export const TooltipTableContainerWithOffset = styled(TooltipTableContainer)`
  margin-top: 64px;
`;

export const HighlightedTable = styled('div')`
  .highlighted-column {
    background-color: #ffcd0b4a;
  }

  button {
    color: #fff !important;
    min-width: 170px;
  }

  .ant-pagination-item-link {
    min-width: auto !important;
  }
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 16px;
  justify-content: center;
`;

export const Asterisx = styled.span`
  color: red;
  font-size: 25px;
  margin-top: -10px;
`;

export const StyledWrapper = styled.div<{ hasEntity?: boolean }>`
  margin-top: ${({ hasEntity }) => (hasEntity ? '60px' : '0')};
`;

export const StyledWrapperWithOffset = styled(StyledWrapper)`
  margin-top: 64px;
`;

export const OpenTooltipBtn = styled(Button)`
  background: #e6f4ff;
  color: black !important;
  padding: 0;
  justify-content: flex-start;
  margin-right: 10px;

  .ant-input-group-addon {
    color: #fff;
    cursor: pointer;
  }
  &: hover {
    background: #e6f4ff !important;
  }
`;

export const ButtonDiv = styled.div<{ isEmpty: boolean }>``;

export const TitleComponent = styled('div')`
  display: flex;

  p {
    margin: 0;
  }
`;

export const ColourReportredFields = styled('div')`
  .ant-select {
    background-color: #ffcd0b4a;
  }
`;

export const IctSystem = styled('div')`
  display: flex;
  gap: 10px;
`;

export const TopScrollBar = styled('div')`
  overflow-x: auto;
  overflow-y: hidden;
  height: 16px;
  margin-bottom: 4px;
`;

export const DateInputs = styled('div')`
  display: flex;
  gap: 8px;
  position: relative;
  align-items: flex-start;
  margin-bottom: 8px;

  strong {
    flex-shrink: 0;
    min-width: 180px;
    max-width: 180px;
    word-wrap: break-word;
    white-space: normal;
    line-height: 1.4;
  }

  .ant-picker {
    width: auto;
  }
`;

export const RelativeDateWrapper = styled('div')`
  position: relative;
`;

export const InputWithMargin = styled('div')`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  margin-bottom: 0;

  strong {
    flex-shrink: 0;
    min-width: 180px;
    max-width: 180px;
    word-wrap: break-word;
    white-space: normal;
    line-height: 1.4;
  }

  input {
    width: auto;
  }
`;
